import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class ChargeRegister {
  /* 大宗出库保存 */
  static postBulkSave(data) {
    const url = `/oa/api/charge/check/save/bulk`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 退货服务保存 */
  static postRefundSave(data) {
    const url = `/oa/api/charge/check/save/refund`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 卸货服务保存 */
  static postUnloadingSave(data) {
    const url = `/oa/api/charge/check/save/unloading`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /*  贴标服务保存 */
  static postLabelSave(data) {
    const url = `/oa/api/charge/check/save/label`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 贴标服务列表 */
  static getServiceLableList(options) {
    let url = `/oa/api/charge/check/list/extra/service?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /*  根据商品编码/规格 获取商品名称 */
  static getGoodsName(code, customerId) {
    const url = `/oa/api/customer/goods/by/code?code=${code}&customerId=${customerId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 服务列表 */
  static getServiceList() {
    const url = `/oa/api/charge/service/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 项目列表 */
  static getProjectList(customerId, warehouseId) {
    const url = `/oa/api/charge/check/project/list?customerId=${customerId}&warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出收费登记 */
  static getExport(options, type) {
    let url
    if (type === 1) {
      url = `/oa/api/download/charge/check/record/bulk?`;
    } else if (type === 2) {
      url = `/oa/api/download/charge/check/record/refund?`;
    } else if (type === 3) {
      url = `/oa/api/download/charge/check/record/unloading?`;
    } else if (type === 4) {
      url = `/oa/api/download/charge/check/record/label?`;
    }
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 大宗出库登记记录列表 */
  static getChargeRecordBulkList(options) {
    let url = `/oa/api/charge/check/list/bulk?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 退货服务登记记录列表 */
  static getChargeRecordRefundList(options) {
    let url = `/oa/api/charge/check/list/refund?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 卸货服务登记记录列表 */
  static getChargeRecordUnloadingList(options) {
    let url = `/oa/api/charge/check/list/unloading?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 贴标服务登记记录列表 */
  static getChargeRecordLabelList(options) {
    let url = `/oa/api/charge/check/list/label?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 作废 */
  static postNullify(data, type) {
    let url
    if (type === 1) {
      url = `/oa/api/charge/check/cancel/bulk`;
    } else if (type === 2) {
      url = `/oa/api/charge/check/cancel/refund`;
    } else if (type === 3) {
      url = `/oa/api/charge/check/cancel/unloading`;
    } else if (type === 4) {
      url = `/oa/api/charge/check/cancel/label`;
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 入库完成 */
  static postFinish(id) {
    const url = `/oa/api/charge/check/complete/refund/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

}

export default ChargeRegister;